<template>
  <div>
    <div class="d-flex mb-2">
      <text-field
        v-model="formData.first_name"
        name="First Name"
        label-class="flex-1 mr-3"
        :errorMessage="
          v$.formData.first_name
            ? firstErrorMessage(v$.formData.first_name)
            : ''
        "
      ></text-field>
      <text-field
        v-model="formData.last_name"
        name="Last Name"
        label-class="flex-1"
        :errorMessage="
          v$.formData.last_name ? firstErrorMessage(v$.formData.last_name) : ''
        "
      ></text-field>
    </div>
    <div v-if="customerClassificationEnabled" class="d-flex mb-2">
      <SelectBox
        v-model="formData.customer_type"
        class="flex-1 mr-3"
        name="customer_type"
        label="Customer Type"
        data-cy="customer-type"
        :allow-empty="false"
        :options="customerTypeOptions"
      />
      <text-field
        v-model="formData.company_name"
        name="Company Name"
        label-class="flex-1"
      ></text-field>
    </div>
    <div class="mb-2">
      <div class="form-control-label"><b>Email</b></div>
      <email-field v-model="formData.email" primary hide-buttons></email-field>
      <div class="form-control-label"><b>Phone</b></div>
      <phone-field
        v-model="formData.phone"
        primary
        hide-buttons
        name="phone"
      ></phone-field>
    </div>
  </div>
</template>

<script>
import {
  CUSTOMER_TYPE_OPTIONS,
  customerClassificationEnabled,
  DEFAULT_CUSTOMER_TYPE
} from "@/lib/customerTypes";
import { getQueryVariables } from "@/lib/url.js";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import SelectBox from "@/components/SelectBox.vue";
import TextField from "@/components/TextField.vue";
import EmailField from "@/Customer/EmailField.vue";
import PhoneField from "@/Customer/PhoneField.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

export default {
  components: {
    SelectBox,
    TextField,
    EmailField,
    PhoneField
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      formData: {
        first_name: "",
        last_name: "",
        company_name: "",
        customer_type: DEFAULT_CUSTOMER_TYPE,
        email: { email_address: "", primary: true },
        phone: { phone_number: "", type: "", primary: true }
      },
      customerClassificationEnabled: customerClassificationEnabled(),
      customerTypeOptions: CUSTOMER_TYPE_OPTIONS
    };
  },
  created() {
    const { first_name, last_name, phone } = getQueryVariables();
    if (first_name !== "Wireless") {
      this.formData.first_name = first_name;
    }
    if (last_name !== "Caller") {
      this.formData.last_name = last_name;
    }
    if (phone) {
      this.formData.phone.phone_number = phone.replace("+", " ");
    }
  },
  validations() {
    return {
      formData: {
        first_name: {
          required: helpers.withMessage("First name is required", required),
          $autoDirty: true
        },
        last_name: {
          required: helpers.withMessage("Last name is required", required),
          $autoDirty: true
        }
      }
    };
  },
  methods: {
    firstErrorMessage,
    async getFormData() {
      const isValid = await this.v$.$validate();
      if (isValid) {
        const {
          first_name,
          last_name,
          company_name,
          customer_type,
          email,
          phone
        } = this.formData;
        // With the flag off the two fields are never shown, so nothing may be
        // classified behind the tenant's back — send the pre-flag payload.
        return {
          first_name,
          last_name,
          ...(this.customerClassificationEnabled
            ? { company_name, customer_type }
            : {}),
          emails: [email],
          phones: [phone]
        };
      }
    },
    async validate() {
      const isValid = await this.v$.$validate();
      return isValid;
    }
  }
};
</script>

<style lang="scss" scoped></style>
